import React, { Component } from "react";
import MyNavbar from "../../components/Navbar/MyNavbar";

import ClientRegistration from "../../components/client/ClientRegistration/ClientRegistration";

export default class ClientRegistrationPage extends Component {
  render() {
    return (
      <div>
        <MyNavbar />
        <ClientRegistration />
      </div>
    );
  }
}



